const PIN_LIMIT_MESSAGE =
  "You can only pin up to 3 messages in this chat. Unpin a message to pin another.";

const getMessageId = (entry) =>
  String(entry?.message?._id || entry?.message || "");

const getPinnedPreview = (message) => {
  if (!message) return "Message";
  if (message.deleted?.isDeleted) return "This message was deleted";
  switch (message.type) {
    case "text":
      return message.content?.text || "Message";
    case "image":
      return "Photo";
    case "video":
      return "Video";
    case "audio":
      return "Audio";
    case "file":
      return message.content?.media?.[0]?.name || "File";
    case "contact":
      return message.content?.contact?.name
        ? `Contact: ${message.content.contact.name}`
        : "Contact";
    default:
      return "Message";
  }
};

const getSenderName = (message) => {
  const first = message?.sender?.first_name || "";
  const last = message?.sender?.last_name || "";
  return `${first} ${last}`.trim() || "Unknown";
};

export default function PinnedMessagesBar({
  pinnedMessages = [],
  onScrollToMessage,
  onUnpin,
  canUnpin = true,
}) {
  if (!pinnedMessages.length) return null;

  return (
    <div className="pinned_messages_bar" role="region" aria-label="Pinned messages">
      <div className="pinned_messages_bar_header">
        <span className="pinned_messages_bar_title">
          <span className="notranslate" aria-hidden="true">📌</span> Pinned
        </span>
      </div>
      <div className="pinned_messages_list">
        {pinnedMessages.map((entry) => {
          const messageId = getMessageId(entry);
          const message = entry.message;
          return (
            <button
              key={messageId || entry.pinnedAt}
              type="button"
              className="pinned_message_row"
              onClick={() => messageId && onScrollToMessage && onScrollToMessage(messageId)}
              title="Jump to message"
            >
              <span className="pinned_message_text">
                <span className="pinned_message_sender">{getSenderName(message)}</span>
                <span className="pinned_message_preview">{getPinnedPreview(message)}</span>
              </span>
              {canUnpin && (
                <span
                  className="pinned_message_unpin"
                  role="button"
                  tabIndex={0}
                  title="Unpin message"
                  onClick={(e) => {
                    e.stopPropagation();
                    onUnpin && onUnpin(messageId);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      e.stopPropagation();
                      onUnpin && onUnpin(messageId);
                    }
                  }}
                >
                  Unpin
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { PIN_LIMIT_MESSAGE };
